import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CheckedOption } from '../checkbox/checkbox-utils.service';

@Component({
    selector: 'app-checkbox-select',
    templateUrl: './checkbox-select.component.html',
    styleUrls: ['./checkbox-select.component.scss'],
    standalone: false
})
export class CheckboxSelectComponent implements OnInit {
	@Input()
	subAreasOptions: CheckedOption[] = [];

	@Input()
	enableScroll? = true;

	@Input()
	attrLabel? = 'name';

	@Input()
	checkBoxAll? = false;

	@Input()
	boldSelectAll? = true;

	@Input()
	allSelect? = false;

	@Output()
	selectEvt = new EventEmitter<any>();

	@Input()
	allPhase? = 'Todos';

	@Input()
	onlySelected? = false;

	@Input()
	onlyView? = false;

	@Input()
	hideSelected? = false;

	@Input()
	onlySelectedOneOption? = false;

	constructor(private changeDectector: ChangeDetectorRef) {}
	ngOnChanges(changes: SimpleChanges): void {}

	ngOnInit() {}

	label(obj) {
		return obj.option[this.attrLabel];
	}

	clearAllOptions() {
		for (const item of this.subAreasOptions) {
			item.checked = false;
		}
	}
	checkAllOptions() {
		for (const item of this.subAreasOptions) {
			item.checked = true;
		}
	}

	forceSelectAll() {
		this.allSelect = true;
		this.checkAllOptions();
	}

	forceEmit() {
		this.emit();
	}

	getSelected() {
		if (this.allSelect) {
			return this.subAreasOptions;
		} else {
			return this.selectChecked();
		}
	}

	isCheckAll() {
		if (Array.isArray(this.subAreasOptions)) {
			this.allSelect = this.subAreasOptions.every(c => c.checked);
		}
		return this.allSelect;
	}

	selectAll() {
		this.allSelect = !this.allSelect;

		// clean others option
		if (this.allSelect) {
			this.checkAllOptions();
			// emit all
			this.emit();
		} else {
			this.unselectedAll();
			this.emit();
		}
	}

	selectChecked() {
		let arr = [];
		for (const item of this.subAreasOptions) {
			if (item.checked) {
				arr.push(item);
			}
		}
		return arr;
	}
	checkIfAllSelect() {
		for (const item of this.subAreasOptions) {
			if (!item.checked) {
				return false;
			}
		}
		return true;
	}

	//  this.allSelect = true;
	//       this.selectAll();

	unselectedAll() {
		this.subAreasOptions.forEach(c => (c.checked = false));
	}
	isAllSelect() {
		let flag = true;
		this.subAreasOptions.forEach(sub => {
			if (!sub.checked) {
				flag = false;
			}
		});
		return flag;
	}

	selectOne(check?: CheckedOption) {
		if (this.onlySelectedOneOption) {
			let a = check.checked;
			this.unselectedAll();
			if (a) {
				check.checked = true;
			}
			this.changeDectector.detectChanges();
		}
		if (this.isAllSelect()) {
			this.allSelect = true;
		} else {
			this.allSelect = false;
		}
		this.emit();
	}
	emit() {
		// separa a lista de selecionados
		if (this.allSelect) {
			// envia todo mundo
			this.selectEvt.emit(this.subAreasOptions);
		} else {
			// monta uma lista com os selecioandos
			// envia
			this.selectEvt.emit(this.selectChecked());
		}
	}

	isAnySelected = (includeHidden?): boolean => {
		if (includeHidden == null) {
			includeHidden = false;
		}
		let flag = false;
		this.subAreasOptions.forEach(area => {
			if (area.checked && !area.hidden && !includeHidden) {
				flag = true;
			}
			if (area.checked && includeHidden) {
				flag = true;
			}
		});
		return flag;
	};
}
